import { Divider } from "antd";
import { PageHeader, Tile } from "../../components";
import { primaryNav } from "../../helpers/config";

const SettingsIndex = ( props ) => {
    const setupNav = primaryNav.filter( nav => nav.name === 'Setup' )[ 0 ];

    return (
        <section>
            <PageHeader title="Setup" description="Configure application level settings and functionality" hasBackButton />
            <Divider className="mt-2" />

            <div className="row py-5">
                { setupNav.children.map( nav =>
                    <div className="mb-3 col-md-3 col-6" key={ nav.name }>
                        <Tile isAction title={ nav.name } icon={ nav.icon } url={ nav.url } />
                    </div>
                ) }
            </div>
        </section>
    );
};

export { SettingsIndex };